"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISMISSED_STATE_ID = exports.ORIGIN_STATE_ID = void 0;
exports.ORIGIN_STATE_ID = '_origin_';
exports.DISMISSED_STATE_ID = '_dismissed_';
//# sourceMappingURL=misc.js.map